export default {
  async getUserVirtualCard(userId, config = {}) {
    return await this.$get({
      url: `${this.$baseurl}/virtual-card/admin/virtual-cards/${userId}`,
      headers: this.headers,
      ...config,
    });
  },
};
